import Ingredients from "../components/Ingredients";
import Preparation from "../components/Preparation";
import RecipeWrapper from "../RecipeWrapper";

function OvenRoastedColaBraisedPulledPorkScreen() {
  function ingredients() {
    return (
      <>
        <Ingredients
          ingredients={[
            {
              count: "1",
              description: "tablespoon brown sugar",
            },
            {
              count: "1/2",
              description: "tablespoon chili powder",
            },
            {
              count: "1/2",
              description: "teaspoon sea salt",
            },
            {
              count: "1/2",
              description: "teaspoon smoked paprika",
            },
            {
              count: "1/4",
              description: "teaspoon black pepper",
            },
            {
              count: "1/4",
              description: "teaspoon dry mustard",
            },
            {
              count: "1/4",
              description: "teaspoon oregano",
            },
            {
              count: "1/4",
              description: "teaspoon garlic powder",
            },
            {
              count: "1/4",
              description: "teaspoon onion powder",
            },
          ]}
          title="Dry Rub"
        />
        <Ingredients
          ingredients={[
            {
              count: "2",
              description: "pounds boneless pork shoulder",
            },
            {
              count: "1",
              description: "tablespoon olive oil",
            },
            {
              count: "1",
              description:
                "cup beer, or substitute Dr. Pepper, root beer, or Coke",
            },
            {
              count: "1/2",
              description: "onion, diced",
            },
          ]}
          title="Pulled Pork"
        />
      </>
    );
  }

  function preparation() {
    return (
      <>
        <Preparation
          steps={[
            "Mix all dry rub seasonings together in a small bowl.",
            "Pat the pork shoulder dry with paper towels.",
            "Coat the pork with the dry rub, wrap it in plastic wrap, and refrigerate for 12 to 24 hours.",
            "Preheat the oven to 300°F.",
            "Heat olive oil in a large oven-safe pot until very hot, then cook the diced onion for 2 to 3 minutes.",
            "Sear the pork on all sides for 3 to 5 minutes per side.",
            "Remove the pot from the heat and add the beer or soda.",
            "Cover the pot and roast on the center oven rack for 2 to 3 hours.",
            "Check after about 90 minutes and add more beer or water if the pan is getting dry.",
            "Cook until the pork reaches an internal temperature of 190°F to 195°F.",
            "Remove from the oven and let the pork cool until it is safe to handle.",
            "Shred the pork with two forks.",
            "Toss the shredded pork with barbecue sauce, adding pan juices if desired to keep it moist.",
            "Serve in tacos, sandwiches, or other pulled pork dishes.",
          ]}
        />
      </>
    );
  }

  return (
    <RecipeWrapper
      ingredients={ingredients()}
      originalRecipeLink="https://www.askchefdennis.com/perfect-pulled-pork/#wprm-recipe-container-83915"
      preparation={preparation()}
      title="Oven Roasted Cola-Braised Pulled Pork"
    />
  );
}

export default OvenRoastedColaBraisedPulledPorkScreen;
